import {
    defaultEndMembershipReason,
    EndMembershipReason,
    EndMembershipReasonMap,
} from "@albertine/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useMemberProfile } from "../../MemberProfileContext";
import { OwnedField } from "../FormFields";
import { FormShell } from "../ProfileOverlayShell";
import type { FormProps } from "../types";

const endMembershipSchema = z.object({
    reason: z.string().pipe(EndMembershipReason),
    additionalNote: z.string(),
});

export function EndMembershipForm({
    kind,
    onClose,
}: FormProps & { kind: "trial" | "paid" }) {
    const { endMembership } = useMemberProfile();
    const { control, handleSubmit } = useForm({
        resolver: zodResolver(endMembershipSchema),
        defaultValues: { reason: defaultEndMembershipReason, additionalNote: "" },
    });

    return (
        <FormShell
            title={
                kind === "trial"
                    ? "End trial membership"
                    : "Cancel subscription renewal"
            }
            onClose={onClose}
            saveLabel="Confirm"
            onSave={handleSubmit((values) => {
                const additionalNote = values.additionalNote.trim();
                endMembership(
                    {
                        reason: values.reason,
                        additionalNote: additionalNote || undefined,
                    },
                    onClose,
                );
            })}
        >
            <OwnedField
                id="end-membership-reason"
                label="Reason"
                kind="select"
                options={EndMembershipReason.options.map((reason) => ({
                    id: reason,
                    label: EndMembershipReasonMap[reason],
                }))}
                control={control}
                name="reason"
            />
            <OwnedField
                id="end-membership-note"
                label="Additional information"
                kind="textarea"
                placeholder="comments"
                optional
                control={control}
                name="additionalNote"
            />
        </FormShell>
    );
}
